<template>
  <div class="container">
    <Header class="is-uppercase has-text-weight-bold" />
    <p v-if="message !== undefined">{{ $t(message) }}</p>
    <p v-else>{{ 'An unknown error occured' | translate }}</p>
    <router-link :to="{ name: 'LP'}" class="has-text-white">{{ 'Try again' | translate }}</router-link>
    <Footer class="is-uppercase has-text-weight-bold" />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  name: 'PaymentError',
  data() {
    return {
      message: this.$route.query.message
    }
  },
  components: {
    Header,
    Footer
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Pages/PaymentError.vue